import { FC, memo } from 'react';

import V2PartnerCompaniesPresenter from './V2PartnerCompaniesPresenter';

const V2PartnerCompanies: FC = memo(() => (
  <V2PartnerCompaniesPresenter />
));

export default V2PartnerCompanies;
